// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Enums =====

import {
    SALE_NEGOTIATION_ITEM_STATUS_TYPE,
}                               from '../enums';

const createSaleNegotiationRequest = async ({
    test,
    requestId,
    sessionId,
    status,
}: {
    test: boolean,
    requestId: string,
    sessionId: string,
    status: SALE_NEGOTIATION_ITEM_STATUS_TYPE,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleCreateSaleNegotiationRequest = httpsCallable<
        Record<
            string,
            boolean | string | SALE_NEGOTIATION_ITEM_STATUS_TYPE
        >,
        boolean
    >(
        functions,
        'createSaleNegotiationRequest',
    );
    return handleCreateSaleNegotiationRequest({
        test,
        requestId,
        sessionId,
        status,
    }).then((result) => {
        const succes = result.data as boolean;
        return succes;
    }).catch((err) => {
        throw err;
    });
};

export default createSaleNegotiationRequest;
